<template>
  <router-view />
</template>

<script>
import { masterBus } from '@/main.js';
import {TweenMax, Power2,CustomEase, TimelineLite} from "gsap/TweenMax";
// import * as PixiPlugin from "gsap/PixiPlugin";

export default {
  name: 'App',
  mounted(){
    if(this.$route.path.indexOf('/de') >= 0){
      this.$store.dispatch('setLanguage','de');
    }
    $( "body" ).keypress(function(event) {
      if(event.keyCode == 98){
        if($(this).hasClass('dark-mode')){
          $(this).removeClass("dark-mode");
          $('.logo_svg').removeClass("light");
          masterBus.$emit('switchDarkMode',false);
        }
        else{
          $(this).addClass("dark-mode");
          $('.logo_svg').addClass("light");
          masterBus.$emit('switchDarkMode',true);
        }
      }
    })
    document.addEventListener('gesturestart', function(e) {
    e.preventDefault();
    // special hack to prevent zoom-to-tabs gesture in safari
    document.body.style.zoom = 0.99;
    })

      document.addEventListener('gesturechange', function(e) {
          e.preventDefault();
          // special hack to prevent zoom-to-tabs gesture in safari
          document.body.style.zoom = 0.99;
      })

      document.addEventListener('gestureend', function(e) {
          e.preventDefault();
          // special hack to prevent zoom-to-tabs gesture in safari
          document.body.style.zoom = 0.999;
      })
      var lastTouchEnd = 0;
      document.addEventListener('touchend', function (event) {
          var now = (new Date()).getTime();
          if (now - lastTouchEnd <= 300) {
              event.preventDefault();
          }
          lastTouchEnd = now;
      }, false);
  }
}
</script>

<style lang="scss">
@font-face {
  font-family: "VWAG-Bold";
  src: url('~/assets/fonts/VWAGTheSans-Bold.ttf');
}
@font-face {
  font-family: "VWAG-Light";
  src: url('~/assets/fonts/VWAGTheSans-Light.ttf');
}
@font-face {
  font-family: "VWAG-Regular";
  src: url('~/assets/fonts/VWAGTheSans-Regular.ttf');
}

body{
  max-height: 100vh;
  overflow: scroll;
  background: white;
  touch-action: none;
  -webkit-touch-action:none;
  font-size: 15px;
  &.dark-mode{
    background: #1a191b;
  }
}
.app{
  // overflow: hidden;
  background: white;
}
* {
  font-family: 'Union Regular', Helvetica, Arial, sans-serif;
  font-weight:  normal;
  font-style:   normal;
  font-stretch: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
  margin:0;
  margin-bottom: 0;
  margin-top: 0;
  padding:0;
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  touch-action: none !important;
  text-decoration: none;
}
*, *:before, *:after {
     -moz-box-sizing: border-box;
     -webkit-box-sizing: border-box;
     box-sizing: border-box;
}
img{
  max-width: 100%;
}
ol, ul, dl{
  list-style: none;
  margin-bottom: 0;
}
p{
  a{
    text-decoration: underline;
  }
}
p,a,span{
  color:#333333;
}
</style>
